import Vue from "vue";
import PaginatedService from "./paginated.service";

class PayablesService extends PaginatedService {
  static get resource() {
    return "admin/payables";
  }

  static get_aggregate() {
    const url = `${this.resource}/aggregate`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getCurrencyAggregate(params) {
    const url = `${this.resource}/aggregate`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, {params})
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static get_analytics(slug, params) {
    const url = `${this.resource}/analytics/${slug}`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, {params})
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static get_top_vendors() {
    const url = `${this.resource}/top-vendors`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default PayablesService;
